import type { MemeIcon as MemeIconType } from "@/types/api";
import { StrapiMedia } from "@/components/shared/StrapiMedia";

type Props = {
    memeIcon: MemeIconType | null | undefined;
};

export function MemeIcon({ memeIcon }: Props) {
    if (!memeIcon?.icon) {
        return null;
    }

    return (
        <div className="size-16 overflow-hidden">
            <StrapiMedia size="sm" image={memeIcon.icon} alt={memeIcon.name ?? ""} className="size-full" />
        </div>
    );
}

export default MemeIcon;
